export default __webpack_public_path__ + "static/media/Others_Jump_Spin.ef8aca37.svg";